import { Link } from 'react-router-dom';
import { categories } from '@/mocks/data';

export default function CategoriesSection() {
  const displayCategories = categories.filter(c => c.slug !== 'all');

  return (
    <section className="py-16 md:py-20 bg-background-100/60">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-12">
          <h2 className="text-2xl md:text-3xl font-bold font-heading text-foreground-900 mb-3">
            探索内容<strong className="text-accent-500">分类</strong>
          </h2>
          <p className="text-foreground-600 text-sm max-w-xl mx-auto">
            七大内容板块，满足您多方面的知识和资讯需求
          </p>
        </div>

        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-7 gap-4">
          {displayCategories.map((cat) => (
            <Link
              key={cat.slug}
              to={`/category/${cat.slug}`}
              className="group flex flex-col items-center gap-3 p-5 rounded-lg bg-background-50 border border-background-200/60 hover:border-accent-300/50 hover:bg-accent-50/30 transition-all duration-300 cursor-pointer"
            >
              <div className="w-12 h-12 flex items-center justify-center rounded-full bg-accent-100 text-accent-600 group-hover:bg-accent-500 group-hover:text-background-50 transition-colors duration-300">
                <i className={`${cat.icon} text-xl`} />
              </div>
              <span className="text-sm font-medium text-foreground-800 group-hover:text-accent-700 transition-colors duration-200 whitespace-nowrap">
                {cat.name}
              </span>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}